import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import queryString from 'query-string';
import { getPartnerApisHeaders } from "./partnerApisHeaders";
const routeToApiMapping = {
  sales: 'sales/transactions',
  evaluations: 'evaluations'
};
/* Gets sales / evaluations reports for a Partner based on Report Name */

export const getSalesOrEvaluationsReports = (mpacBaseUrl, partnerId, reportName, queryParams = {}) => {
  const metric = queryParams.metric ? String(queryParams.metric) : 'hosting';
  return fetchOk("".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/reporting/").concat(routeToApiMapping[reportName], "/").concat(metric, "?").concat(queryString.stringify(queryParams)), {
    headers: getPartnerApisHeaders()
  }).then(response => response.json());
};